import { ReactNode } from 'react';
import { joinNodes } from 'utils/joinNodes';
import { getItemCountText } from 'utils/string';

type SelectionSummaryProps = Readonly<{
    corporationIds: ReadonlySet<string>;
    /** the selected locations outside of `corporationIds` */
    extraLocationIds: ReadonlySet<string>;
}>;

export function SelectionSummary({
    corporationIds,
    extraLocationIds,
}: SelectionSummaryProps) {
    const extraLocationCount = extraLocationIds.size;

    if (corporationIds.size + extraLocationCount === 0) {
        return <>No selections</>;
    }

    const parts: ReactNode[] = [];
    if (corporationIds.size > 0) {
        parts.push(getItemCountText(corporationIds.size, 'Corporation'));
    }
    if (extraLocationCount > 0) {
        parts.push(getItemCountText(extraLocationCount, 'Location'));
    }

    // 3 Corporations, 6 Locations
    return joinNodes(parts, ', ');
}
